<div class="row">
  <div class="col-11" style="padding-right: 0px">
    <div class="row mb-3">
      <div class="col form-field-container" *ngIf="serviceType === 'WMS' || serviceType === 'WMTS'" [formGroup]="form">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>{{ 'map.sidebar.dynamic_layers.form.layers' | translate }}</mat-label>
          <mat-select formControlName="layer" required>
            <mat-option *ngFor="let layer of layerIDs" [value]="layer">
              {{ findTitle(layer) }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls.layer.hasError('required')"
            >{{ 'common.required_field' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-icon
          color="primary"
          class="me-2 clickable info-button"
          [inline]="true"
          #tooltip="matTooltip"
          [matTooltip]="'map.sidebar.dynamic_layers.form.tooltips.layers' | translate"
          matTooltipPosition="above"
          matTooltipClass="info-button-tooltip"
          >info</mat-icon
        >
      </div>
      <div
        class="col form-field-container"
        *ngIf="serviceType === 'XYZ' || serviceType === 'Vector'"
        [formGroup]="form"
      >
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>{{ 'map.sidebar.dynamic_layers.form.url' | translate }}</mat-label>
          <input matInput formControlName="url" required />
          <mat-error *ngIf="form.controls.url.hasError('required')"
            >{{ 'common.required_field' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-icon
          color="primary"
          class="me-2 clickable info-button"
          [inline]="true"
          #tooltip="matTooltip"
          [matTooltip]="'map.sidebar.dynamic_layers.form.tooltips.layers' | translate"
          matTooltipPosition="above"
          matTooltipClass="info-button-tooltip"
          >info</mat-icon
        >
      </div>

      <div class="col form-field-container" [formGroup]="form">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>{{ 'map.sidebar.dynamic_layers.form.title' | translate }}</mat-label>
          <input matInput formControlName="title" required />
          <mat-error *ngIf="form.controls.title.hasError('required')"
            >{{ 'common.required_field' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-icon
          color="primary"
          class="me-2 clickable info-button"
          [inline]="true"
          #tooltip="matTooltip"
          [matTooltip]="'map.sidebar.dynamic_layers.form.tooltips.title' | translate"
          matTooltipPosition="above"
          matTooltipClass="info-button-tooltip"
          >info</mat-icon
        >
      </div>
    </div>

    <div class="row mb-3" [formGroup]="form">
      <div class="col form-field-container" *ngIf="form.controls.type">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>{{ 'map.sidebar.dynamic_layers.form.type' | translate }}</mat-label>
          <mat-select formControlName="type" required>
            <mat-option *ngFor="let type of typeVectorList" [value]="type">
              {{ type }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls.type.hasError('required')">
            {{ 'common.required_field' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-icon
          color="primary"
          class="me-2 clickable info-button"
          [inline]="true"
          #tooltip="matTooltip"
          [matTooltip]="'map.sidebar.dynamic_layers.form.tooltips.type' | translate"
          matTooltipPosition="above"
          matTooltipClass="info-button-tooltip"
          >info</mat-icon
        >
      </div>

      <div class="col form-field-container" *ngIf="form.controls.format">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>{{ 'map.sidebar.dynamic_layers.form.format' | translate }}</mat-label>
          <mat-select formControlName="format" required>
            <mat-option *ngFor="let format of availableFormats" [value]="format">
              {{ format }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls.format.hasError('required')"
            >{{ 'common.required_field' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-icon
          color="primary"
          class="me-2 clickable info-button"
          [inline]="true"
          #tooltip="matTooltip"
          [matTooltip]="'map.sidebar.dynamic_layers.form.tooltips.format' | translate"
          matTooltipPosition="above"
          matTooltipClass="info-button-tooltip"
          >info</mat-icon
        >
      </div>

      <div class="col form-field-container" *ngIf="form.controls.crs">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>{{ 'map.sidebar.dynamic_layers.form.crs' | translate }}</mat-label>
          <mat-select
            formControlName="crs"
            required
            placeholder="EPSG:****"
            [matTooltip]="getSelectedTooltipInfo(form.get('crs').value)"
          >
            <mat-option
              *ngFor="let projection of availableProjections"
              [value]="projection.code"
              #tooltip="matTooltip"
              matTooltipPosition="right"
              [matTooltip]="getTooltipInfo(projection)"
            >
              {{ getDisplayName(projection) }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls.crs.hasError('required')">{{
            'common.required_field' | translate
          }}</mat-error>
        </mat-form-field>
        <mat-icon
          color="primary"
          class="me-2 clickable info-button"
          [inline]="true"
          #tooltip="matTooltip"
          [matTooltip]="'map.sidebar.dynamic_layers.form.tooltips.crs' | translate"
          matTooltipPosition="above"
          matTooltipClass="info-button-tooltip"
          >info</mat-icon
        >
      </div>

      <div class="col form-field-container" *ngIf="form.controls.tilematrixset">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>{{ 'map.sidebar.dynamic_layers.form.matrixSet' | translate }}</mat-label>
          <mat-select formControlName="tilematrixset" required>
            <mat-option *ngFor="let matrixset of availableTileMatrixSets" [value]="matrixset">
              {{ matrixset }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls.tilematrixset.hasError('required')">{{
            'common.required_field' | translate
          }}</mat-error>
        </mat-form-field>
        <mat-icon
          color="primary"
          class="me-2 clickable info-button"
          [inline]="true"
          #tooltip="matTooltip"
          [matTooltip]="'map.sidebar.dynamic_layers.form.tooltips.matrixSet' | translate"
          matTooltipPosition="above"
          matTooltipClass="info-button-tooltip"
          >info</mat-icon
        >
      </div>

      <div class="col form-field-container" *ngIf="form.controls.dataProjection">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>{{ 'map.sidebar.dynamic_layers.form.dataProjection' | translate }}</mat-label>
          <input
            matInput
            formControlName="dataProjection"
            [required]="form.controls.dataProjection.errors ? form.controls['dataProjection'].errors.required : null"
          />
          <mat-error *ngIf="form.controls.dataProjection.hasError('required')">{{
            'common.required_field' | translate
          }}</mat-error>
        </mat-form-field>
        <mat-icon
          color="primary"
          class="me-2 clickable info-button"
          [inline]="true"
          #tooltip="matTooltip"
          [matTooltip]="'map.sidebar.dynamic_layers.form.tooltips.dataProjection' | translate"
          matTooltipPosition="above"
          matTooltipClass="info-button-tooltip"
          >info</mat-icon
        >
      </div>

      <div class="col form-field-container" *ngIf="form.controls.featureProjection">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>{{ 'map.sidebar.dynamic_layers.form.featureProjection' | translate }}</mat-label>
          <input
            matInput
            formControlName="featureProjection"
            [required]="
              form.controls.featureProjection.errors ? form.controls['featureProjection'].errors.required : null
            "
          />
          <mat-error *ngIf="form.controls.featureProjection.hasError('required')">{{
            'common.required_field' | translate
          }}</mat-error>
        </mat-form-field>
        <mat-icon
          color="primary"
          class="me-2 clickable info-button"
          [inline]="true"
          #tooltip="matTooltip"
          [matTooltip]="'map.sidebar.dynamic_layers.form.tooltips.featureProjection' | translate"
          matTooltipPosition="above"
          matTooltipClass="info-button-tooltip"
          >info</mat-icon
        >
      </div>

      <div class="col form-field-container" *ngIf="form.controls.styles">
        <mat-form-field
          class="col form-field-container"
          appearance="fill"
          *ngIf="form.controls.styles"
          [floatLabel]="'always'"
        >
          <mat-label>{{ 'map.sidebar.dynamic_layers.form.styles' | translate }}</mat-label>
          <input
            matInput
            formControlName="styles"
            [required]="form.controls.styles.errors ? form.controls['styles'].errors.required : null"
          />
          <mat-error *ngIf="form.controls.styles.hasError('required')">{{
            'common.required_field' | translate
          }}</mat-error>
        </mat-form-field>
        <mat-icon
          color="primary"
          class="me-2 clickable info-button"
          [inline]="true"
          #tooltip="matTooltip"
          [matTooltip]="'map.sidebar.dynamic_layers.form.tooltips.styles' | translate"
          matTooltipPosition="above"
          matTooltipClass="info-button-tooltip"
          >info</mat-icon
        >
      </div>
    </div>
  </div>
  <div class="col-1">
    <button mat-icon-button style="left: 50%; transform: translateX(-50%)" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<div class="row" *ngIf="serviceType == 'WMS'">
  <div class="col-12 image" [formGroup]="form">
    <mat-slide-toggle formControlName="image">
      <span class="image-text">{{ 'map.sidebar.dynamic_layers.form.imageType' | translate }}</span>
    </mat-slide-toggle>
    <mat-icon
      class="image-icon"
      [matTooltip]="
        (form.get('image').value
          ? 'map.sidebar.dynamic_layers.form.tooltips.image'
          : 'map.sidebar.dynamic_layers.form.tooltips.tile'
        ) | translate
      "
      >{{ form.get('image').value ? 'image' : 'layers' }}</mat-icon
    >
  </div>
</div>
